/** Shared values for delayed agency posting — a shift can wait N hours before going to the agency. */

/** Smallest delay allowed. Matches the backend. */
export const MIN_AGENCY_POST_DELAY_HOURS = 1;

/** Fallback only — the real default comes from the department. */
export const DEFAULT_AGENCY_POST_DELAY_HOURS = 72;

/** The department's default delay, for API responses predating the column. */
export const getDepartmentPostDelayHours = (department: { agencyPostDelayDefaultHours?: number }): number =>
	department.agencyPostDelayDefaultHours ?? DEFAULT_AGENCY_POST_DELAY_HOURS;

/**
 * The typed delay as a number the backend will accept, or `null` if it won't.
 *
 * The `min` on a number input is browser metadata only — it doesn't stop a submit, and an empty
 * field reads back as `Number("") === 0`. Every place that sends a delay validates through here so
 * a cleared, fractional, or junk value can't reach the API.
 */
export const parseDelayHours = (value: string): number | null => {
	if (value.trim() === "") return null;
	const parsed = Number(value);
	if (!Number.isInteger(parsed) || parsed < MIN_AGENCY_POST_DELAY_HOURS) return null;
	return parsed;
};
